<script >
/* eslint-disable better-max-params/better-max-params */
import { ref, onMounted, defineProps, defineEmits } from 'vue-demi';
import ContentPart from './ContentPart.vue';
import SwiperContainer from './Swiper/SwiperContainer.vue';
import SwiperSlide from './Swiper/SwiperSlide.vue';
const __sfc_main = {};
__sfc_main.props = {
  partTle: {
    type: String,
    default: ''
  },
  showTab: {
    type: String,
    default: false
  },
  list: {
    type: Array,
    default: []
  },
  dlgActive: {
    type: Number,
    default: 0
  },
  dataList: {
    type: Array,
    default: []
  },
  rateColorCls: {
    type: String,
    default: ''
  },
  langText: {
    type: String,
    default: ''
  },
  isEn: {
    type: Boolean,
    default: false
  },
  isNn: {
    type: Boolean,
    default: false
  },
  isPi: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport
  } = require('@fegobull/webapi').use;
  useTeleport(document.body);
  const swiper2 = ref(null);
  const props = __props;
  const swiperOpt = ref({
    slidesPerView: 'auto',
    loopedSlides: 3,
    autoplay: false,
    grabCursor: true,
    autoWidth: true,
    loop: false
  });
  const emit = __ctx.emit;
  const subscribeStock = (evt, item, idx, idx1) => {
    emit('dowch', evt, item, idx, idx1);
  };
  const unsubscribeStock = (evt, item, idx, idx1) => {
    emit('unwch', evt, item, idx, idx1);
  };
  const changeDlgIdx = async (evt, idx, item) => {
    swiper2.value.slideTo(idx);
    emit('change', evt, idx, item);
  };
  onMounted(() => {
    swiper2.value.slideTo(props.dlgActive);
    swiper2.value.inst.update();
  });
  return {
    swiper2,
    swiperOpt,
    subscribeStock,
    unsubscribeStock,
    changeDlgIdx
  };
};
__sfc_main.components = Object.assign({
  SwiperContainer,
  SwiperSlide,
  ContentPart
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <div class="act-dialog productdlg" :class=[langText]>
        <div class="act-dialog-wrapper">
            <div class="trade-idea-produc-titlect">
                <div class="maintitle">{{ partTle }}</div>
                <div class="closeicon" @click="$emit('close')"></div>
            </div>
            <div class="trade-idea-produc-tab" v-if="showTab">
                <swiper-container :opt="swiperOpt" ref="swiper2">
                    <swiper-slide v-for="(item, idx) in list" :key="'item_2_' + idx">
                        <div class="item" :class="{'current':dlgActive===idx}" @click="changeDlgIdx($event, idx, item)">
                            {{ item.tabName }}
                        </div>
                    </swiper-slide>
                </swiper-container>
            </div>
            <ContentPart
                :list="list"
                :active-idx="dlgActive"
                :data-list="dataList"
                :lang-text="langText"
                :rate-color-cls="rateColorCls"
                :is-en="isEn"
                :is-dlg="true"
                :is-NN="isNN"
                :is-pi="isPi"
                @dowch="subscribeStock"
                @unwch="unsubscribeStock"
                @change="changeDlgIdx"
            />
        </div>
    </div>
</template>
